import type { MenuConfig } from '~typings/menu'
import permisosPresupuesto, { RESOURCE_PRESUPUESTO } from '@/auth/permissions/modules/presupuesto'
import mantenimiento from './mantenimiento'
import configuracion from './configuracion'
import transacciones from './transacciones'
import informes from './informes'
export default [
    {
        title: 'presupuesto.menu_title',
        fontIcon: 'dollar',
        resource: RESOURCE_PRESUPUESTO,
        action: permisosPresupuesto._root,
        children: [
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                action: permisosPresupuesto.mantenimiento._perm,
                children: mantenimiento
            },
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                action: permisosPresupuesto.configuracion._perm,
                children: configuracion
            },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                action: permisosPresupuesto.transacciones._perm,
                children: transacciones
            },
            {
                title: 'global.menu.informes',
                fontIcon: 'file-prescription',
                action: permisosPresupuesto.informes._perm,
                children: informes
            },
        ],
    }
] as MenuConfig[]
